import { render, staticRenderFns } from "./invoice-hits-list.vue?vue&type=template&id=c4c65472"
import script from "./invoice-hits-list.vue?vue&type=script&lang=js"
export * from "./invoice-hits-list.vue?vue&type=script&lang=js"
import style0 from "./invoice-hits-list.vue?vue&type=style&index=0&id=c4c65472&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports